import { Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
import * as Yup from "yup";

import { axiosInstance } from "../../utils/axios-instance";

import { useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// import { GeneralTextInput } from "../Custom-Forms/General-Text-Input";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
// import { EnterNewPasswordSubmission } from "./Enter-New-Password-Submission";
import { Verify2faEmailSubmission } from "./Verify-2fa-email-submission"

import { selectSignIn } from "../../store/slices/signed-in-slice";

import { fetchEmail2faVerified } from '../../store/thunks/fetch-email-2fa-verified-thunk'

export const Verify2faEmail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);
    const [searchParams] = useSearchParams();

    const [submitted, setSubmitted] = useState(false);

    // Get id in url '?client_id={client_id}'
    const client_id = searchParams.get("client_id");
    // Get type in url 'type={type}'
    // either 'signin' or 'signup'
    const type = searchParams.get("type");

    const enterPhoneCodeValidationSchema = Yup.object({
        email_code: Yup.string()
            .required("Required")
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(6, "Must be exactly 6 digits")
            .max(6, "Must be exactly 6 digits")
    });

    // If the id or token in the URL param is empty, navigate to a different page
    useEffect(() => {
        if (client_id === null) {
            navigate("/signin");
        }
    });

    return (
        <>
            <>
                <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                    <h1>Email 2FA Verification:</h1>
                    <Row className="card-background card-font">
                        <Formik
                            initialValues={{
                                email_code: ""
                            }}
                            validationSchema={enterPhoneCodeValidationSchema}
                            onSubmit={async (
                                values,
                                { setStatus }
                            ) => {
                                if (values.email_code.length != 6) {
                                    setStatus({ error: false });
                                    setSubmitted(false);
                                }
                                try {
                                    const response = await axiosInstance({
                                        method: "post",
                                        url: `/verify-phone`,
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        data: {
                                            email_code: values.email_code,
                                            client_id: client_id
                                        }
                                    });
                                    setStatus({ error: false });
                                    setSubmitted(true);
                                    dispatch(fetchEmail2faVerified())
                                    if(type === 'security-settings') {
                                        setTimeout(() => {
                                            navigate('/security-settings');
                                        }, 2500);
                                    }
                                } catch (error) {
                                    setStatus({ error: true });
                                    // console.error(error);
                                    return Promise.reject(error);
                                }
                            }}
                        >
                            <Form>
                                <Row>
                                    
                                    <h4>Enter the 6-digit code we sent to you. It may take a minute for the email to arrive. Do not close this window</h4>
                                </Row>
                                <Row>
                                    {type === 'security-settings' && (
                                        <h5 className="text-danger">Code expires in 15 minutes.</h5>
                                    )}
                                    
                                </Row>
                                
                                <Row className="mb-3">
                                    <Row className="mx-0">
                                        <GeneralTextAreaField
                                            autoFocus
                                            label="6-Digit Code:"
                                            className="form-control"
                                            component="input"
                                            name="email_code"
                                            type="text"
                                            rows="1"
                                            placeholder="6 digit code"
                                            autoComplete="one-time-code"
                                            aria-required="true"
                                        />
                                    </Row>
                                </Row>
                                <Verify2faEmailSubmission  submitted={submitted}/>
                                
                                
                                {/* <EnterNewPasswordSubmission
                                    props={{ showPassword, setShowPassword }}
                                /> */}
                            </Form>
                        </Formik>
                    </Row>
                </Container>
            </>
        </>
    );
};
